// lms crc code tssss

import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { LosService } from "../../_LOS/services/los.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { constantUrl } from "../../Shared/constantUrl";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { LmsService } from "../services/lms.service";
declare var $: any;

@Component({
  selector: "app-lms-crc-fill",
  templateUrl: "./lms-crc-fill.component.html",
  styleUrls: ["./lms-crc-fill.component.scss"],
  standalone: false,
})
export class LmsCrcFillComponent implements OnInit {
  currentUser: any;
  isShowSave: boolean = true;
  isShowEdit: boolean = false;
  showSpinner: boolean = false;
  DetailCRCShow: boolean = false;
  isShowUpdate: boolean = false;
  CibilApiShow: boolean = false;
  experianAPIShow: boolean = false;
  CibilApisurepassShow: boolean = false;
  CRIFApiShow: boolean = false;
  EquifaxApiShow: boolean = false;
  cibilCheckType: any;
  CibilApidecisioncentreShow: boolean = false;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  AddButtonShow: boolean = true;
  crcModel: any = {};
  CRC_Type: any;
  SelectCRCType: any;
  ApplicationDetail: any;
  LoanId: any;
  DocModel: any = {};
  DocModel1: any = {};
  loading: boolean = false;
  FormCRCShow: boolean = true;
  CurrentDate: any = new Date();
  OTPCode: any;
  docBaseUrl: any = constantUrl.CrcApplicationDocUrl;
  customerProfileBaseUrl: any = constantUrl.customerProfilePicUrl;
  AllowExtension: any = constantUrl.AllowExtension;
  datasourceCRC: any;
  displayedCRCColumns: any = [
    "CRC_AgencyName",
    "Application_No",
    "CRC_LoanTypeName",
    "CRC_CreditVisionScore",
    "CRC_PersonalLoanScore",
    "CRC_Remarks",
    "Origin",
    "Fetch_Previous_CRC",
    "Action",
  ];

  kycList: any[] = [];
  CRC_LoanTypeDropDown: any[] = [];
  CRC_Agency: any;
  today: Date = new Date();
  inViewMode: boolean = false;
  Type: any;
  @Input("Data") Data: any;
  @Input("isEdit") isEdit: boolean = false;
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  //Type: any;
  @Input() loanSummary: any;
  @Input() CustomerId: any;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  CRCList: any = [];
  PageAcess: any;
  CRC_Agency_Bind: any;
  Response: any;
  cibilResponse: any;
  cibilResponseSurePass: any;
  ResponseSurePass: any;
  OTP: any;
  crifResponse: any;
  criferror: any;
  error: any = true;
  dataUrl: any;
  experianResponse: any;
  CustomerNameRequest: any;
  CustomerPhoneRequest: any;
  panNumberforExperian: any;

  IsFetchCibil: boolean = false;
  selectedRowForFetch: any;
  isPreviousCRC: any;
  IsCRC_Frequency: boolean = false;
  EquifaxErrorMessage: any;
  CrifAPIDigiverificationShow: boolean = false;

  constructor(
    private _MasterService: MasterService,
    private LmsService: LmsService,
    private dataSharingService: DataSharingService,
    private encdec: EncrDecrService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private router: Router,
    private losService: LosService,
    private http: HttpClient,
    private dialog: DialogService,
  ) {
    this.route.paramMap.subscribe((param: ParamMap) => {
      //this.LoanId = param.get("id");// encdec.decrypt(param.get("id"));
      // this.CustomerId = param.get("cid");// encdec.decrypt(param.get("cid"));
      //this.LoanId = param.get("LA-No");

      let AllPage = JSON.parse(sessionStorage.getItem("AllPageAcess"));
      this.PageAcess = AllPage.filter((x) => x.Page_Name == "CRC");
    });
  }
  ngOnInit(): void {
    this.CustomerId = this.CustomerId;
    this.LoanId = this.loanSummary.LoanId;
    this.getAgency();
    //this.dataSharingService.LOSHeaderTitle.next('CRC Fill');
    this.dataSharingService.LOSHeaderTitle.next("CRC Fill");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.GetLmsCRCCustomerDetail();
    this.Get_CibilAPI_Error_Response();
  }

  getOrigin(row: any): string {
    if (
      (row.CRC_Agency == 1 && row.isView == 1) ||
      (row.CRC_Agency == 1 && row.isViewSurepass == 1) ||
      (row.CRC_Agency == 4 && row.isViewCrifApi == 1) ||
      (row.CRC_Agency == 3 && row.isViewexperianSurepass == 1) ||
      (row.CRC_Agency == 2 && row.isViewEquifax == 1) ||
      (row.CRC_Agency == 4 && row.isViewCrifApi_DigiVerify == 1)
    ) {
      return "Automatic";
    } else {
      return "Manual";
    }
  }

  GetLmsCRCCustomerDetail() {
    // this.Type = Type;
    this.showSpinner = true;

    this.LmsService.GetLmsCRCCustomerDetail({
      Loan_Id: this.loanSummary.LoanId,
      CId: this.CustomerId,
    }).subscribe((res: any) => {
      this.showSpinner = false;
      this.ApplicationDetail = res.Item1[0];
      this.IsCRC_Frequency = res.Item1[0].CRC_Frequency > 0;
      console.log("this.IsCRC_Frequency", this.IsCRC_Frequency);

      this.panNumberforExperian = res.Item2.find(
        (doc) => doc.DocId == 1,
      )?.KYC_DocNumber;

      this.kycList = res.Item2;
      var inViewMode =
        this.ApplicationDetail.CRC_Status == "Completed" ||
        this.ApplicationDetail.CRC_Status == "Rejected";
      this.crcModel = res.Item3[0] || {
        CRC_Agency: this.ApplicationDetail.DefaultCRCAgency || "",
        CRC_Recommendation: "",
      };
      this.datasourceCRC = new MatTableDataSource(res.Item3);
      console.log("datasourceCRC", this.datasourceCRC);
      this.CRCList = res.Item3;
      if (
        this.ApplicationDetail.TransUnionCibilAPI &&
        this.ApplicationDetail.IsFirm != 1
      ) {
        var _find = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 1 && obj.CRC_LoanId == this.loanSummary.LoanId
          );
        });
        console.log(_find);
        if (!_find) {
          var _find1 = this.CRCList.find((obj: any) => {
            return (
              obj.CRC_Agency == this.ApplicationDetail.DefaultCRCAgency &&
              obj.CRC_LoanId == this.loanSummary.LoanId
            );
          });
          console.log(_find1);

          if (!_find1) {
            if (
              this.ApplicationDetail.DefaultCRCAgency == 1 ||
              this.ApplicationDetail.DefaultCRCAgency == "1"
            ) {
              this.CibilApiShow = true;
              this.AddButtonShow = false;
            } else {
              this.CibilApiShow = false;
              this.IsFetchCibil = true;
              this.AddButtonShow = true;
            }
          } else {
            this.CibilApiShow = true;
            this.AddButtonShow = true;
          }
        } else {
          this.CibilApiShow = false;
          this.AddButtonShow = true;
        }
        var applicableCRC = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 1 &&
            obj.CRC_LoanId == this.loanSummary.LoanId &&
            obj.CRC_Status_By_Frequency === "Applicable"
          );
        });

        if (applicableCRC) {
          this.CibilApiShow = true;
        }
      }
      if (
        this.ApplicationDetail.TransUnionCibilAPISurepass &&
        this.ApplicationDetail.IsFirm != 1
      ) {
        var _find = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 1 && obj.CRC_LoanId == this.loanSummary.LoanId
          );
        });
        console.log(_find);
        if (!_find) {
          var _find1 = this.CRCList.find((obj: any) => {
            return (
              obj.CRC_Agency == this.ApplicationDetail.DefaultCRCAgency &&
              obj.CRC_LoanId == this.loanSummary.LoanId
            );
          });
          console.log(_find1);

          if (!_find1) {
            if (
              this.ApplicationDetail.DefaultCRCAgency == 1 ||
              this.ApplicationDetail.DefaultCRCAgency == "1"
            ) {
              this.CibilApisurepassShow = true;
              this.AddButtonShow = false;
            } else {
              this.CibilApisurepassShow = false;
              this.IsFetchCibil = true;
              this.AddButtonShow = true;
            }
          } else {
            this.CibilApisurepassShow = true;
            this.AddButtonShow = true;
          }
        } else {
          this.CibilApisurepassShow = false;
          this.AddButtonShow = true;
        }
        var applicableCRC = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 1 &&
            obj.CRC_LoanId == this.loanSummary.LoanId &&
            obj.CRC_Status_By_Frequency === "Applicable"
          );
        });

        if (applicableCRC) {
          this.CibilApisurepassShow = true;
        }
      }
      if (
        this.ApplicationDetail.Transuniondecisioncentre &&
        this.ApplicationDetail.IsFirm != 1
      ) {
        var _find = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 1 && obj.CRC_LoanId == this.loanSummary.LoanId
          );
        });
        console.log(_find);
        if (!_find) {
          var _find1 = this.CRCList.find((obj: any) => {
            return (
              obj.CRC_Agency == this.ApplicationDetail.DefaultCRCAgency &&
              obj.CRC_LoanId == this.loanSummary.LoanId
            );
          });
          console.log(_find1);

          if (!_find1) {
            if (
              this.ApplicationDetail.DefaultCRCAgency == 1 ||
              this.ApplicationDetail.DefaultCRCAgency == "1"
            ) {
              this.CibilApidecisioncentreShow = true;
              this.AddButtonShow = false;
            } else {
              this.CibilApidecisioncentreShow = false;
              this.IsFetchCibil = true;
              this.AddButtonShow = true;
            }
          } else {
            this.CibilApidecisioncentreShow = true;
            this.AddButtonShow = true;
          }
        } else {
          this.CibilApidecisioncentreShow = false;
          this.AddButtonShow = true;
        }
        var applicableCRC = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 4 &&
            obj.CRC_LoanId == this.loanSummary.LoanId &&
            obj.CRC_Status_By_Frequency === "Applicable"
          );
        });

        if (applicableCRC) {
          this.CibilApidecisioncentreShow = true;
        }
      }

      //Crif
      if (
        this.ApplicationDetail.CRIFAPI &&
        this.ApplicationDetail.IsFirm != 1
      ) {
        var _find = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 4 && obj.CRC_LoanId == this.loanSummary.LoanId
          );
        });
        console.log(_find);
        if (!_find) {
          var _find1 = this.CRCList.find((obj: any) => {
            return (
              obj.CRC_Agency == this.ApplicationDetail.DefaultCRCAgency &&
              obj.CRC_LoanId == this.loanSummary.LoanId
            );
          });
          console.log(_find1);

          if (!_find1) {
            if (
              this.ApplicationDetail.DefaultCRCAgency == 4 ||
              this.ApplicationDetail.DefaultCRCAgency == "4"
            ) {
              this.CRIFApiShow = true;
              this.AddButtonShow = false;
            } else {
              this.CRIFApiShow = false;
              this.IsFetchCibil = true;
              this.AddButtonShow = true;
            }
          } else {
            this.CRIFApiShow = true;
            this.IsFetchCibil = true;
            this.AddButtonShow = true;
          }
        } else {
          this.CRIFApiShow = false;
          this.IsFetchCibil = true;
          this.AddButtonShow = true;
        }
        var applicableCRC = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 4 &&
            obj.CRC_LoanId == this.loanSummary.LoanId &&
            obj.CRC_Status_By_Frequency === "Applicable"
          );
        });

        if (applicableCRC) {
          this.CRIFApiShow = true;
        }
      }

       //Crif DigiVerification
      if (
        this.ApplicationDetail.CRIFDigiVerification  &&
        this.ApplicationDetail.IsFirm != 1
      ) {
        var _find = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 4 && obj.CRC_LoanId == this.loanSummary.LoanId
          );
        });
        if (!_find) {
          var _find1 = this.CRCList.find((obj: any) => {
            return (
              obj.CRC_Agency == this.ApplicationDetail.DefaultCRCAgency &&
              obj.CRC_LoanId == this.loanSummary.LoanId
            );
          });

          if (!_find1) {
            if (
              this.ApplicationDetail.DefaultCRCAgency == 4 ||
              this.ApplicationDetail.DefaultCRCAgency == "4"
            ) {
              this.CrifAPIDigiverificationShow = true;
              // this.IsFetchCibil = true;
              this.AddButtonShow = false;
            } else {
              this.CrifAPIDigiverificationShow = false;
              this.IsFetchCibil = true;
              this.AddButtonShow = false;
            }
          } else {
            this.CrifAPIDigiverificationShow = true;
            this.IsFetchCibil = true;
            this.AddButtonShow = true;
          }
        } else {
          this.CrifAPIDigiverificationShow = false;
          this.IsFetchCibil = true;
          this.AddButtonShow = true;
        }
        var applicableCRC = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 4 &&
            obj.CRC_LoanId == this.loanSummary.LoanId &&
            obj.CRC_Status_By_Frequency === "Applicable"
          );
        });

        if (applicableCRC) {
          this.CrifAPIDigiverificationShow = true;
        }
        console.log("CRIFApiShow", this.CrifAPIDigiverificationShow);
      }
      // experian
      if (
        this.ApplicationDetail.ExperianAPISurepass &&
        this.ApplicationDetail.IsFirm != 1
      ) {
        var _find = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 3 && obj.CRC_LoanId == this.loanSummary.LoanId
          );
        });
        console.log(_find);
        if (!_find) {
          var _find1 = this.CRCList.find((obj: any) => {
            return (
              obj.CRC_Agency == this.ApplicationDetail.DefaultCRCAgency &&
              obj.CRC_LoanId == this.loanSummary.LoanId
            );
          });
          console.log(_find1);

          if (!_find1) {
            if (
              this.ApplicationDetail.DefaultCRCAgency == 3 ||
              this.ApplicationDetail.DefaultCRCAgency == "3"
            ) {
              this.experianAPIShow = true;
              this.AddButtonShow = false;
            } else {
              this.experianAPIShow = false;
              this.IsFetchCibil = true;
              this.AddButtonShow = true;
            }
          } else {
            this.experianAPIShow = true;
            this.AddButtonShow = true;
          }
        } else {
          this.experianAPIShow = false;
          this.AddButtonShow = true;
        }
        var applicableCRC = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 3 &&
            obj.CRC_LoanId == this.loanSummary.LoanId &&
            obj.CRC_Status_By_Frequency === "Applicable"
          );
        });

        if (applicableCRC) {
          this.experianAPIShow = true;
        }
      }

      // Equifax
      if (
        (this.ApplicationDetail.EquifaxApi ||
          this.ApplicationDetail.EquifaxAPI ||
          this.ApplicationDetail.EquifaxAPISurepass) &&
        this.ApplicationDetail.IsFirm != 1
      ) {
        var _findEquifax = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 2 && obj.CRC_LoanId == this.loanSummary.LoanId
          );
        });
        if (!_findEquifax) {
          var _findEquifax1 = this.CRCList.find((obj: any) => {
            return (
              obj.CRC_Agency == this.ApplicationDetail.DefaultCRCAgency &&
              obj.CRC_LoanId == this.loanSummary.LoanId
            );
          });

          if (!_findEquifax1) {
            if (
              this.ApplicationDetail.DefaultCRCAgency == 2 ||
              this.ApplicationDetail.DefaultCRCAgency == "2"
            ) {
              this.EquifaxApiShow = true;
              this.AddButtonShow = false;
            } else {
              this.EquifaxApiShow = false;
              this.IsFetchCibil = true;
              this.AddButtonShow = true;
            }
          } else {
            this.EquifaxApiShow = true;
            this.IsFetchCibil = true;
            this.AddButtonShow = true;
          }
        } else {
          this.EquifaxApiShow = false;
          this.IsFetchCibil = true;
          this.AddButtonShow = true;
        }
        var applicableEquifaxCRC = this.CRCList.find((obj: any) => {
          return (
            obj.CRC_Agency == 2 &&
            obj.CRC_LoanId == this.loanSummary.LoanId &&
            obj.CRC_Status_By_Frequency === "Applicable"
          );
        });

        if (applicableEquifaxCRC) {
          this.EquifaxApiShow = true;
        }
        console.log("EquifaxApiShow", this.EquifaxApiShow);
      }

      console.log("this.AddButtonShow", this.AddButtonShow);
      if (res.Item3[0] != undefined) {
        if (
          this.crcModel.CRC_OldestAccountOpenDate != null &&
          this.crcModel.CRC_OldestAccountOpenDate != ""
        )
          this.crcModel.CRC_OldestAccountOpenDate = new Date(
            this.crcModel.CRC_OldestAccountOpenDate,
          );
        if (
          this.crcModel.CRC_RecentAccountOpenDate != null &&
          this.crcModel.CRC_RecentAccountOpenDate != ""
        )
          this.crcModel.CRC_RecentAccountOpenDate = new Date(
            this.crcModel.CRC_RecentAccountOpenDate,
          );
        if (
          this.crcModel.CRC_LastEnquiryDate != null &&
          this.crcModel.CRC_LastEnquiryDate != ""
        )
          this.crcModel.CRC_LastEnquiryDate = new Date(
            this.crcModel.CRC_LastEnquiryDate,
          );
      }
      if (this.crcModel.CRC_Agency) {
        this.GET_CRC_LoanType(false);
      }
      this.getCRCType(this.crcModel.CRC_Agency);

      this.crcModel.CRC_CreateBy = this.currentUser.userId;
      //console.log("inViewMode ", inViewMode);
      if (inViewMode == true) {
        this.DetailCRCShow = true;
        this.FormCRCShow = false;
        this.isShowEdit = true;
        this.isShowSave = false;
        this.isShowUpdate = false;
      } else {
        this.DetailCRCShow = false;
        this.FormCRCShow = true;
        this.getCRCType(this.crcModel.CRC_Agency);
        this.isShowEdit = false;
        this.isShowSave = true;
        this.isShowUpdate = false;
      }

      //this._MasterService
      //  .Get_CibilAPI_Request_Response({
      //    Loan_Id: this.LoanId,
      //    CId: this.CustomerId,
      //  })
      //  .subscribe((res: any) => {
      //    if (res.length > 0) {
      //      this.CibilApiShow = false;
      //      this.experianAPIShow = false;
      //      this.CibilApisurepassShow = false;
      //      this.CibilApidecisioncentreShow = false;
      //      this.AddButtonShow = true;
      //    }
      //  });
    });
  }
  get currentLoanCRCCount(): number {
    if (!this.CRCList) return 0;

    return this.CRCList.filter(
      (x: any) => x.CRC_LoanId == this.loanSummary.LoanId,
    ).length;
  }
  getCRCType(event: any) {
    this.LmsService.GET_CRC_MASTER_BY_CRCAGENCY({
      Crc_Agency: this.crcModel.CRC_Agency,
    }).subscribe((res: any) => {
      this.CRC_Type = res;
    });
  }
  getAgency() {
    this._MasterService
      .Commaon_Master({ Commands: "Select", Type: "CRC AGENCY" })
      .subscribe((res: any) => {
        this.CRC_Agency_Bind = res;
      });
  }
  fileChangeListener(files: any) {
    // debugger;
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    let Ext = sanitizedFileName.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB && Ext != "pdf") {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      this.crcModel.CRC_ReportName = "";
      this.DocModel.DocName = "";
      this.DocModel.DocData = "";
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Invalid file type`,
        ...this.configSuccess,
      });
      files.value = "";
      this.crcModel.CRC_ReportName = "";
      this.DocModel.DocName = "";
      this.DocModel.DocData = "";
      return;
    }

    let $this = this;
    let reader = new FileReader();
    let _pre = this.today.getTime();
    this.crcModel.CRC_ReportName = _pre + "_" + sanitizedFileName;
    this.DocModel.DocName = _pre + "_" + sanitizedFileName;
    this.DocModel.ApplicationNo = this.loanSummary.ApplicationNo;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      $this.DocModel.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }
  removeFile(input: any) {
    input.value = "";
    this.crcModel.CRC_ReportName = "";
    this.DocModel.DocName = "";
    this.DocModel.DocData = "";
  }
  fileChangeListener1(files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB && Ext != "pdf") {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      this.crcModel.CRC_ReportName1 = "";
      this.DocModel1.DocName = "";
      this.DocModel1.DocData = "";
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Invalid file type`,
        ...this.configSuccess,
      });
      files.value = "";
      this.crcModel.CRC_ReportName1 = "";
      this.DocModel1.DocName = "";
      this.DocModel1.DocData = "";
      return;
    }

    let $this = this;
    let reader = new FileReader();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    if (
      this.crcModel.CRC_ReportName &&
      this.crcModel.CRC_ReportName.split("_")[1] == sanitizedFileName
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Same File can not be upload.",
        ...this.configSuccess,
      });
      return;
    }
    let _pre = this.today.getTime();
    this.crcModel.CRC_ReportName1 = _pre + "_" + sanitizedFileName;
    this.DocModel1.DocName = _pre + "_" + sanitizedFileName;
    this.DocModel1.ApplicationNo = this.loanSummary.ApplicationNo;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      $this.DocModel1.DocData = reader.result
        .toString()
        .split(";base64,")
        .pop();
      return;
    };
  }
  removeFile1(input: any) {
    input.value = "";
    this.crcModel.CRC_ReportName1 = "";
    this.DocModel1.DocName = "";
    this.DocModel1.DocData = "";
  }
  onSaveCrc() {
    if (!this.DocModel.DocData) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please upload CRC report.",
        ...this.configSuccess,
      });
    } else {
      this.UploadCrcDoc();
    }
  }

  UpdateCrc() {
    if (this.DocModel.DocData) {
      this.losService.UploadCrcDoc(this.DocModel).subscribe((res: any) => {
        if (this.DocModel1.DocData) {
          this.UpdateCrcDoc1();
        } else {
          this.UpdateCrcReport();
        }
      });
    } else {
      //this.UploadCrcDoc();
      if (!this.crcModel.CRC_ReportName) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Please upload CRC report.",
          ...this.configSuccess,
        });
      } else {
        this.UpdateCrcReport();
      }
    }
  }

  UpdateCrc1() {
    //console.log("update this.crcModel", this.crcModel);
    if (!this.DocModel.DocData) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please upload CRC report.",
        ...this.configSuccess,
      });
    } else {
      //this.UploadCrcDoc();
      this.showSpinner = true;

      this.losService.UploadCrcDoc(this.DocModel).subscribe(
        (res: any) => {
          if (this.DocModel1.DocData) {
            this.UpdateCrcDoc1();
          } else {
            // this.saveCrcReport();
            this.losService.UploadCrcDoc(this.DocModel1).subscribe(
              (res: any) => {
                this.UpdateCrcReport();
              },
              (err: any) => {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: "File not uploaded.",
                  ...this.configSuccess,
                });
              },
            );
          }
        },
        (err: any) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "File not uploaded.",
            ...this.configSuccess,
          });
        },
      );
    }
  }
  UpdateCrcReport() {
    this.loading = true;
    this.crcModel.CRC_ApplicationId = 0;
    this.crcModel.LoanId = this.loanSummary.LoanId;
    this.crcModel.CRC_CustomerId = this.CustomerId;
    if (
      this.crcModel.CRC_CreditVisionScore == null ||
      this.crcModel.CRC_CreditVisionScore == 0
    )
      this.crcModel.CRC_CreditVisionScore = "0";
    if (
      this.crcModel.CRC_PersonalLoanScore == null ||
      this.crcModel.CRC_PersonalLoanScore == 0
    )
      this.crcModel.CRC_PersonalLoanScore = "0";
    // console.log("this.Update", this.crcModel);
    this.LmsService.LmsUpdateCrc({
      JSON: JSON.stringify({
        CRC: this.dataSharingService.cleanObject(this.crcModel),
      }),
    }).subscribe((res: any) => {
      this.loading = false;
      this.showSpinner = false;
      if (res[0].CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
        //this.QuickLoan_Save_PageProcess('CRC');
        this.OnClose(true);
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
    });
  }
  saveCrcReport() {
    this.loading = true;
    //console.log("this.crcModel", this.crcModel);
    this.crcModel.LoanId = this.loanSummary.LoanId;
    this.crcModel.CRC_CustomerId = this.CustomerId;
    this.crcModel.CRC_ApplicationId = 0;
    this.crcModel.CRC_CreateBy = this.currentUser.userId;
    if (
      this.crcModel.CRC_CreditVisionScore == null ||
      this.crcModel.CRC_CreditVisionScore == 0
    )
      this.crcModel.CRC_CreditVisionScore = "0";
    if (
      this.crcModel.CRC_PersonalLoanScore == null ||
      this.crcModel.CRC_PersonalLoanScore == 0
    )
      this.crcModel.CRC_PersonalLoanScore = "0";
    this.LmsService.LmsSaveCrc({
      JSON: JSON.stringify({
        CRC: this.dataSharingService.cleanObject(this.crcModel),
      }),
    }).subscribe((res: any) => {
      this.loading = false;
      this.showSpinner = false;
      if (res[0].CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
        //this.QuickLoan_Save_PageProcess('CRC');
        this.OnClose(true);
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
    });
  }
  UploadCrcDoc() {
    this.showSpinner = true;
    this.losService.UploadCrcDoc(this.DocModel).subscribe(
      (res: any) => {
        if (this.DocModel1.DocData) {
          this.UploadCrcDoc1();
        } else {
          this.saveCrcReport();
        }
      },
      (err: any) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "File not uploaded.",
          ...this.configSuccess,
        });
      },
    );
  }
  UploadCrcDoc1() {
    this.losService.UploadCrcDoc(this.DocModel1).subscribe(
      (res: any) => {
        this.saveCrcReport();
      },
      (err: any) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "File not uploaded.",
          ...this.configSuccess,
        });
      },
    );
  }
  UpdateCrcDoc1() {
    this.losService.UploadCrcDoc(this.DocModel1).subscribe(
      (res: any) => {
        this.UpdateCrcReport();
      },
      (err: any) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "File not uploaded.",
          ...this.configSuccess,
        });
      },
    );
  }

  OnClose(isRefresh: boolean = false) {
    // setTimeout(() => {
    //   this.dataSharingService.LmsHeaderLoanNo.next(this.LoanNo);
    // }, 2);

    //this.router.navigate([
    //  `/lms/lms-crc-list`,
    //]);
    // let element: HTMLElement = document.getElementById("CrcInfo") as HTMLElement;
    // element.click();
    this.close.emit(isRefresh);
    //this.action.emit(isRefresh);
  }
  EditCRC() {
    this.isShowEdit = false;
    this.isShowSave = false;
    this.inViewMode = false;
    this.DetailCRCShow = false;
    this.FormCRCShow = true;
    this.isShowUpdate = true;
  }

  //QuickLoan_Save_PageProcess(PageType) {
  //  this._QuickLoanService.QuickLoan_Save_PageProcess({
  //    PageType: PageType, ProductId: this.loanSummary.ProductId, Loan_Id: this.loanSummary.LoanId,
  //    Process_Id: this.Processid, Page_Id: this.PageData.MM_Id, LoginUserId: this.currentUser.userId
  //  }).subscribe((res) => {
  //    //return res[0].CODE;
  //  });
  //}
  getCRCDetail(data: any, isEdit: boolean) {
    this.isPreviousCRC = data.CRC_LoanId != this.loanSummary.LoanId;
    this.crcModel = data;
    this.GET_CRC_LoanType(false);
    this.isShowEdit = true;
    this.isShowSave = false;
    this.isShowUpdate = false;
    this.inViewMode = true;
    if (
      this.crcModel.CRC_OldestAccountOpenDate != null &&
      this.crcModel.CRC_OldestAccountOpenDate != "" &&
      this.crcModel.CRC_OldestAccountOpenDate != "0001-01-01T00:00:00"
    )
      this.crcModel.CRC_OldestAccountOpenDate = new Date(
        this.crcModel.CRC_OldestAccountOpenDate,
      );
    else {
      this.crcModel.CRC_OldestAccountOpenDate = null;
    }
    if (
      this.crcModel.CRC_RecentAccountOpenDate != null &&
      this.crcModel.CRC_RecentAccountOpenDate != "" &&
      this.crcModel.CRC_RecentAccountOpenDate != "0001-01-01T00:00:00"
    )
      this.crcModel.CRC_RecentAccountOpenDate = new Date(
        this.crcModel.CRC_RecentAccountOpenDate,
      );
    else this.crcModel.CRC_RecentAccountOpenDate = null;
    if (
      this.crcModel.CRC_LastEnquiryDate != null &&
      this.crcModel.CRC_LastEnquiryDate != "" &&
      this.crcModel.CRC_LastEnquiryDate != "0001-01-01T00:00:00"
    )
      this.crcModel.CRC_LastEnquiryDate = new Date(
        this.crcModel.CRC_LastEnquiryDate,
      );
    else this.crcModel.CRC_LastEnquiryDate = null;

    this.crcModel.CRC_ApplicationId = this.LoanId;
    this.crcModel.CRC_CustomerId = this.CustomerId;
    this.crcModel.CRC_CreateBy = this.currentUser.userId;
    //  this.crcModel.CRC_OldestAccountOpenDate = new Date(this.crcModel.CRC_OldestAccountOpenDate);
    //   this.crcModel.CRC_RecentAccountOpenDate = new Date(this.crcModel.CRC_RecentAccountOpenDate);
    //   this.crcModel.CRC_LastEnquiryDate = new Date(this.crcModel.CRC_LastEnquiryDate);
    this.crcModel.SourceApplicationNo = data.Application_No;
    $("#AdditionalCRC").modal("show");
    $("#AdditionalCRC").css("z-index", "1050");
  }
  RemoveElementFromArray(element: number) {
    this.CRC_Agency_Bind.forEach((value, index) => {
      if (value.Id == element) this.CRC_Agency_Bind.splice(index, 1);
    });
  }
  GET_CRC_LoanType(isChange: boolean = true) {
    if (isChange) {
      this.crcModel.CRC_LoanType = "";
    }
    this.losService
      .GET_CRC_MASTER_BY_CRCAGENCY({
        Crc_Agency: this.crcModel.CRC_Agency,
        Is_Firm: this.ApplicationDetail.IsFirm,
      })
      .subscribe((res: any) => {
        this.CRC_LoanTypeDropDown = res;
      });
  }
  AddCRC() {
    if (this.CRCList.length == 0) {
      this.crcModel.CRC_Agency = this.ApplicationDetail.deDefaultCRCAgency;
      this.GET_CRC_LoanType();
      this.crcModel = {
        CRC_Agency: this.ApplicationDetail.DefaultCRCAgency || "",
        CRC_LoanType: "",
        CRC_Recommendation: "",
      };
    } else {
      this.crcModel = {
        CRC_Agency: "",
        CRC_LoanType: "",
        CRC_Recommendation: "",
      };
    }

    //if (
    //  this.CibilApiShow ||
    //  this.CibilApidecisioncentreShow ||
    //  this.CibilApisurepassShow
    //) {
    //  this.RemoveElementFromArray(1);
    //}
    //if (this.CRIFApiShow) {
    //  this.RemoveElementFromArray(4);
    //}
    //if (this.experianAPIShow) {
    //  this.RemoveElementFromArray(3);
    //}
    this.CRCList.forEach((obj1) => {
      // this.RemoveElementFromArray(Number(obj1.CRC_Agency));
      if (
        obj1.CRC_LoanId === this.loanSummary.LoanId &&
        obj1.CRC_Status_By_Frequency != "Applicable"
      ) {
        this.RemoveElementFromArray(Number(obj1.CRC_Agency));
      }
    });

    // });

    //this.CRC_Agency_Bind = this.CRC_Agency_Bind.filter(x => x.Id == "Cheque & Repayment")
    this.isShowEdit = false;
    this.isShowSave = true;
    this.isShowUpdate = false;
    this.inViewMode = false;

    console.log(" this.crcModel ", this.crcModel);
    $("#AdditionalCRC").modal("show");
    $("#AdditionalCRC").css("z-index", "1050");
  }
  Delete_CRC(data: any) {
    this.loading = true;
    this.crcModel = data;
    this.crcModel.CRC_ApplicationId = 0;
    this.crcModel.LoanId = this.LoanId;
    this.crcModel.CRC_CustomerId = this.CustomerId;
    if (
      this.crcModel.CRC_CreditVisionScore == null ||
      this.crcModel.CRC_CreditVisionScore == 0
    )
      this.crcModel.CRC_CreditVisionScore = "0";
    if (
      this.crcModel.CRC_PersonalLoanScore == null ||
      this.crcModel.CRC_PersonalLoanScore == 0
    )
      this.crcModel.CRC_PersonalLoanScore = "0";
    // console.log("this.Update", this.crcModel);
    this.crcModel.Mode = "Delete";
    this.LmsService.LmsUpdateCrc({
      JSON: JSON.stringify({
        CRC: this.dataSharingService.cleanObject(this.crcModel),
      }),
    }).subscribe((res: any) => {
      this.loading = false;
      this.showSpinner = false;
      if (res[0].CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
        this.OnClose();
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
    });
    this.OnAdditionalCRCClose();
  }
  OnAdditionalCRCClose() {
    this.getAgency();
    $("#AdditionalCRC").modal("hide");
  }
  CheckCibil() {
    this.CibilApiShow = false;

    if (
      this.ApplicationDetail.LoanAmount == undefined ||
      this.ApplicationDetail.LoanAmount == null ||
      this.ApplicationDetail.LoanAmount == 0
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please fill Account Information!!",
        ...this.configSuccess,
      });
    } else {
      let LoanAmount: string =
        "0".repeat(9 - this.ApplicationDetail.LoanAmount.toString().length) +
        this.ApplicationDetail.LoanAmount.toString();

      var ids = [];
      this.kycList.forEach((value, index) => {
        if (value.Doc_Type_Cibil != "" && value.Doc_Type_Cibil != null) {
          ids.push({
            index: "I0" + (index + 1).toString(),
            idNumber: value.KYC_DocNumber,
            idType: value.Doc_Type_Cibil,
          });
        }
      });
      var replacementArray = [
        "!",
        "#",
        "$",
        "%",
        "&",
        "*",
        ",",
        "/",
        "?",
        "@",
        "/",
        " ^ ",
        " | ",
        "~",
        " + ",
        "=",
      ];
      for (let i = 0; i < replacementArray.length; i++) {
        this.ApplicationDetail.Customer_FirstName =
          this.ApplicationDetail.Customer_FirstName.replace(
            replacementArray[i],
            "",
          );
        this.ApplicationDetail.Customer_LastName =
          this.ApplicationDetail.Customer_LastName.replace(
            replacementArray[i],
            "",
          );
        this.ApplicationDetail.Line1 = this.ApplicationDetail.Line1.replace(
          replacementArray[i],
          "",
        );
        this.ApplicationDetail.Line2 = this.ApplicationDetail.Line2.replace(
          replacementArray[i],
          "",
        );
        ids.forEach((value, index) => {
          value.idNumber = value.idNumber.replace(replacementArray[i], "");
        });
      }
      var chunks = this.splitStringIntoChunks(this.ApplicationDetail.Line1, 35);

      let _data: any = {
        gstStateCode: this.ApplicationDetail.gstStateCode,
        enquiryPurpose: this.ApplicationDetail.enquiryPurpose,
        memberRefNo: this.ApplicationDetail.ApplicationNo,
        firstName: this.ApplicationDetail.Customer_FirstName,
        middleName: "",
        lastName: this.ApplicationDetail.Customer_LastName,
        birthDate: this.ApplicationDetail.DOB,
        gender: this.ApplicationDetail.GenderCode,
        telephoneNumber: this.ApplicationDetail.Customer_PhoneNo,
        addressStateCode: this.ApplicationDetail.address_StateCode,
        pinCode: this.ApplicationDetail.PinCode,

        line1: chunks[0] == undefined ? "" : chunks[0],
        line2: chunks[1] == undefined ? "" : chunks[1],
        line3: chunks[2] == undefined ? "" : chunks[2],
        line4: chunks[3] == undefined ? "" : chunks[3],
        line5:
          this.splitStringIntoChunks(this.ApplicationDetail.Line2, 35)[0] ==
          undefined
            ? ""
            : this.splitStringIntoChunks(this.ApplicationDetail.Line2, 35)[0],
        residenceCode: this.ApplicationDetail.residenceCode,
        enquiryAmount: LoanAmount,
        ids: ids,
      };
      console.log("_data", chunks);
      if (
        this.ApplicationDetail.TotalKyc_ForCibil > 0 &&
        this.ApplicationDetail.TotalKyc_ForCibil > ids.length
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data:
            "Minimum " +
            this.ApplicationDetail.TotalKyc_ForCibil +
            " KYC Required For Cibil Check!!",
          ...this.configSuccess,
        });
        this.CibilApiShow = true;
      } else {
        this.LmsService.FetchCivilData({
          loginUserId: this.currentUser.userId,
          loanId: this.LoanId,
          CustomerId: this.CustomerId,
          JSON: _data,
        }).subscribe((res: any) => {
          console.log("res", res);
          this.Response = res;
          this.cibilResponse = res;
          console.log("Cibil JSON", this.cibilResponse);
          this.error = this.cibilResponse?.controlData?.success;
          if (this.cibilResponse?.controlData?.success == "true") {
            this.error = this.cibilResponse?.controlData?.success;
            $("#cibilReport").modal("show");
            $("#cibilReport").css("z-index", "1050");
            this.CibilApiShow = false;
          } else if (this.cibilResponse?.Description == "Invalid API Key") {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: this.cibilResponse.Description,
              ...this.configSuccess,
            });
          } else {
            $("#cibilReport").modal("show");
            $("#cibilReport").css("z-index", "1050");
            this.CibilApiShow = true;
          }
        });
      }
    }
  }

  checkExperian() {
    if (!this.panNumberforExperian || this.panNumberforExperian.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please fill the PAN Number!",
        ...this.configSuccess,
      });
      return;
    }

    this.showSpinner = true;

    this.LmsService.FetchExperianData({
      name: this.ApplicationDetail?.Customer,
      consent: "Y",
      mobile: this.ApplicationDetail?.PhoneNo,
      pan: this.panNumberforExperian,
      loanId: this.LoanId,
      customerId: this.CustomerId,
      loginUserId: this.currentUser.userId,
    }).subscribe((res: any) => {
      console.log("res", res);
      this.Response = res;
      this.experianResponse = res;
      console.log("experianResponse json", this.experianResponse);
      this.error = this.experianResponse?.success;
      if (this.experianResponse?.success == "true") {
        // this.error = this.cibilResponse?.status_code;
        $("#experianReport").modal("show");
        $("#experianReport").css("z-index", "1050");
        this.experianAPIShow = false;
        this.showSpinner = false;
      } else {
        $("#experianReport").modal("show");
        $("#experianReport").css("z-index", "1050");
        this.experianAPIShow = true;
        this.showSpinner = false;
      }
    });
  }

  onCloseExperianReportModel() {
    this.OnClose(true);
    $("#experianReport").modal("hide");
  }

  splitStringIntoChunks(str: string, size: number): string[] {
    let chunks: string[] = [];
    let words = str.split(" ");
    let currentChunk = "";

    for (let word of words) {
      if (currentChunk.length + word.length + 1 <= size) {
        currentChunk += (currentChunk ? " " : "") + word;
      } else {
        if (currentChunk) {
          chunks.push(currentChunk);
        }
        currentChunk = word;
      }
    }

    if (currentChunk) {
      chunks.push(currentChunk);
    }

    return chunks;
  }
  onCloseCibilReport() {
    this.OnClose(true);
    $("#cibilReport").modal("hide");
  }
  getCRCThirdDetail() {
    this._MasterService
      .Get_CibilAPI_Request_Response({
        Loan_Id: this.LoanId,
        CId: this.CustomerId,
        CrcId: 0,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.cibilResponse = JSON.parse(res[0].response);

          console.log("Cibil JSON", this.cibilResponse);
          $("#cibilReport").modal("show");
          $("#cibilReport").css("z-index", "1050");
        }
      });
  }
  CheckCibildecisioncentre() {
    this.showSpinner = true;
    if (
      this.ApplicationDetail.LoanAmount == undefined ||
      this.ApplicationDetail.LoanAmount == null ||
      this.ApplicationDetail.LoanAmount == 0
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please fill Account Information!!",
        ...this.configSuccess,
      });
    } else {
      let LoanAmount: string =
        "0".repeat(9 - this.ApplicationDetail.LoanAmount.toString().length) +
        this.ApplicationDetail.LoanAmount.toString();

      var ids = [];
      this.kycList.forEach((value, index) => {
        if (value.Doc_Type_Cibil != "" && value.Doc_Type_Cibil != null) {
          ids.push({
            IdNumber: value.KYC_DocNumber,
            IdType: value.Doc_Type_Cibil,
          });
        }
      });
      var replacementArray = [
        "!",
        "#",
        "$",
        "%",
        "&",
        "*",
        ",",
        "/",
        "?",
        "@",
        "/",
        " ^ ",
        " | ",
        "~",
        " + ",
        "=",
      ];
      for (let i = 0; i < replacementArray.length; i++) {
        this.ApplicationDetail.Customer_FirstName =
          this.ApplicationDetail.Customer_FirstName.replace(
            replacementArray[i],
            "",
          );
        this.ApplicationDetail.Customer_LastName =
          this.ApplicationDetail.Customer_LastName.replace(
            replacementArray[i],
            "",
          );
        this.ApplicationDetail.Line1 = this.ApplicationDetail.Line1.replace(
          replacementArray[i],
          "",
        );
        this.ApplicationDetail.Line2 = this.ApplicationDetail.Line2.replace(
          replacementArray[i],
          "",
        );
        ids.forEach((value, index) => {
          value.IdNumber = value.IdNumber.replace(replacementArray[i], "");
        });
      }
      var chunks = this.splitStringIntoChunks(this.ApplicationDetail.Line1, 35);

      let _data: any = {
        gstStateCode: this.ApplicationDetail.gstStateCode,
        enquiryPurpose: this.ApplicationDetail.enquiryPurpose,
        memberRefNo: this.ApplicationDetail.ApplicationNo,
        firstName: this.ApplicationDetail.Customer_FirstName,
        middleName: "",
        email:
          this.ApplicationDetail.Email == null
            ? ""
            : this.ApplicationDetail.Email,
        lastName: this.ApplicationDetail.Customer_LastName,
        birthDate: this.ApplicationDetail.DOB,
        gender: this.ApplicationDetail.Gender,
        telephoneNumber: this.ApplicationDetail.Customer_PhoneNo,
        addressStateCode: this.ApplicationDetail.address_StateCode,
        pinCode: this.ApplicationDetail.PinCode,

        line1: chunks[0] == undefined ? "" : chunks[0],
        line2: chunks[1] == undefined ? "" : chunks[1],
        line3: chunks[2] == undefined ? "" : chunks[2],
        line4: chunks[3] == undefined ? "" : chunks[3],
        line5:
          this.splitStringIntoChunks(this.ApplicationDetail.Line2, 35)[0] ==
          undefined
            ? ""
            : this.splitStringIntoChunks(this.ApplicationDetail.Line2, 35)[0],
        residenceCode: this.ApplicationDetail.residenceCode,
        enquiryAmount: LoanAmount,
        ids: ids,
      };
      if (
        this.ApplicationDetail.TotalKyc_ForMFI > 0 &&
        this.ApplicationDetail.TotalKyc_ForMFI > ids.length
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data:
            "Minimum " +
            this.ApplicationDetail.TotalKyc_ForMFI +
            " KYC Required For Cibil Check!!",
          ...this.configSuccess,
        });
        this.showSpinner = false;
      } else {
        this.LmsService.FetchTransunionDecisionCentreData({
          loginUserId: this.currentUser.userId,
          loanId: this.LoanId,
          CustomerId: this.CustomerId,
          JSON: _data,
        }).subscribe((res: any) => {
          if (res.length > 0) {
            this.LmsService.FetchTransunionDecisionDocument({
              Identifier: res[0].CODE.toString(),
            }).subscribe((response: any) => {
              if (response != null) {
                this.saveAs(response, res[0].MSG);
                this.blobToBase64Async(response, res[0].MSG);
              }
            });
          }
        });
      }
    }
  }
  uploadData(filename) {
    this.DocModel1.DocName = filename;
    this.DocModel1.ApplicationNo = this.loanSummary.ApplicationNo;

    this.DocModel1.DocData = this.dataUrl;

    this.losService.UploadCrcDoc(this.DocModel1).subscribe((res: any) => {
      console.log("upload success");
      this.showSpinner = false;
      this.OnClose(true);
    });
  }
  saveAs(blob: Blob, fileName: string) {
    console.log("Save as pdf fn");
    const link = document.createElement("a");
    link.download = fileName;
    link.href = window.URL.createObjectURL(blob);
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
  blobToBase64Async(blob: Blob, filename): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      let $this = this;
      fileReader.onerror = (e) => reject(fileReader.error);

      fileReader.onload = function () {
        $this.dataUrl = fileReader.result.toString().split(";base64,").pop();
        $this.uploadData(filename);
        return;
      };
      fileReader.readAsDataURL(blob);
    });
  }
  CheckCRIF() {
    if (
      this.ApplicationDetail.CRIF_Code != undefined &&
      this.ApplicationDetail.CRIF_Code != null &&
      this.ApplicationDetail.CRIF_Code != ""
    ) {
      if (
        this.ApplicationDetail.Relation_Code != undefined &&
        this.ApplicationDetail.Relation_Code != null &&
        this.ApplicationDetail.Relation_Code != ""
      ) {
        this.showSpinner = true;
        this.CRIFApiShow = false;

        const day1 = this.ApplicationDetail.DOB.substring(0, 2);
        const month1 = this.ApplicationDetail.DOB.substring(2, 4);
        const year1 = this.ApplicationDetail.DOB.substring(4, 8);

        const DOB = `${day1}-${month1}-${year1}`;
        var ids = [];
        this.kycList.forEach((value, index) => {
          if (value.Doc_Type_Crif != "" && value.Doc_Type_Crif != null) {
            ids.push({
              TYPE: "ID" + value.Doc_Type_Crif.toString(),
              VALUE: value.KYC_DocNumber,
            });
          }
        });
        const currentDate = new Date();

        // Format date and time as DDMMYYYYHHmmSS
        const day = currentDate.getDate().toString().padStart(2, "0");
        const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
        const year = currentDate.getFullYear();
        const hours = currentDate.getHours().toString().padStart(2, "0");
        const minutes = currentDate.getMinutes().toString().padStart(2, "0");
        const seconds = currentDate.getSeconds().toString().padStart(2, "0");

        // Generate a random 6-digit number
        const randomNum = Math.floor(100000 + Math.random() * 900000);

        // Concatenate the result
        var ReferenceNo = `${day}${month}${year}${hours}${minutes}${seconds}${randomNum}`;

        let _data: any = {
          REQUEST_FILE: {
            HEADER_SEGMENT: {
              PRODUCT_TYPE: "",
              PRODUCT_VER: "",
              USER_ID: "",
              USER_PWD: "",
              REQ_MBR: "",
              INQ_DT_TM: "",
              REQ_VOL_TYPE: "",
              REQ_ACTN_TYPE: "",
              AUTH_FLG: "",
              AUTH_TITLE: "",
              RES_FRMT: "",
              MEMBER_PREF_OVERRIDE: "",
              RES_FRMT_EMBD: "",
              LOS_NAME: "",
              LOS_VENDOR: "",
              LOS_VERSION: "",
              REQ_SERVICES_TYPE: "",
            },
            INQUIRY: {
              APPLICANT_SEGMENT: {
                APPLICANT_ID: this.ApplicationDetail.ApplicationNo,
                FIRST_NAME: this.ApplicationDetail.Customer_FirstName,
                MIDDLE_NAME: "",
                LAST_NAME: this.ApplicationDetail.Customer_LastName,
                DOB: {
                  DOB_DT: DOB,
                  AGE: "",
                  AGE_AS_ON: "",
                },
                RELATIONS: [
                  {
                    TYPE: this.ApplicationDetail.Relation_Code,
                    VALUE: this.ApplicationDetail.Relation,
                  },
                ],
                IDS: ids,
                ADDRESSES: [
                  {
                    TYPE: "D04",
                    ADDRESS_TEXT: this.ApplicationDetail.Line1.replace(
                      "\n",
                      "",
                    ).replace("\n", ""),
                    CITY: this.ApplicationDetail.Line2.replace(
                      "\n",
                      "",
                    ).replace("\n", ""),
                    STATE: this.ApplicationDetail.address_TextStateCode,
                    LOCALITY: "",
                    PIN: this.ApplicationDetail.PinCode,
                    COUNTRY: "INDIA",
                  },
                ],
                GENDER: this.ApplicationDetail.GenderCodeCrif,
                INCOME: "",
                EMPLOYMENT_TYPE: "",
                EMPLOYER_NAME: "",
                PHONES: [
                  {
                    TYPE: "P04",
                    VALUE: this.ApplicationDetail.PhoneNo,
                  },
                ],
                EMAILS: [
                  {
                    EMAIL: "",
                  },
                ],
                ACCOUNT_NUMBER: "",
              },
              APPLICATION_SEGMENT: {
                INQUIRY_UNIQUE_REF_NO: ReferenceNo,
                CREDIT_RPT_ID: "",
                CREDIT_RPT_TRN_DT_TM: "",
                CREDIT_INQ_PURPS_TYPE: "CP06",
                CREDIT_INQUIRY_STAGE: "",
                CLIENT_CONTRIBUTOR_ID: "",
                BRANCH_ID: "",
                APPLICATION_ID: this.ApplicationDetail.ApplicationNo,
                ACNT_OPEN_DT: "",
                LOAN_AMT: this.ApplicationDetail.LoanAmount,
                LTV: "",
                TERM: "",
                LOAN_TYPE: this.ApplicationDetail.CRIF_Code,
                LOAN_TYPE_DESC: this.ApplicationDetail.Crc_Type,
              },
            },
          },
        };

        console.log("_data", _data);
        if (
          this.ApplicationDetail.TotalKyc_ForCrif > 0 &&
          this.ApplicationDetail.TotalKyc_ForCrif > ids.length
        ) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data:
              "Minimum " +
              this.ApplicationDetail.TotalKyc_ForCrif +
              " KYC Required For Cibil Check!!",
            ...this.configSuccess,
          });
          this.CRIFApiShow = true;
          this.showSpinner = false;
        } else {
          this.LmsService.FetchCrifData({
            loginUserId: this.currentUser.userId,
            loanId: this.LoanId,
            CustomerId: this.CustomerId,
            JSON: _data,
          }).subscribe((res: any) => {
            // console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", res);
            this.Response = res;
            this.crifResponse = res;
            console.log("Crif JSON", this.crifResponse);
            var _find = this.crifResponse.includes("html");
            if (!_find) {
              this.showSpinner = false;
              var criferror1 = JSON.parse(this.crifResponse);
              criferror1 = criferror1?.["CIR-REPORT-FILE"]?.ERRORS;
              console.log("criferror", criferror1);
              this.criferror = [];
              criferror1.forEach((value, index) => {
                this.criferror.push({
                  errorCode: value?.["ERROR-CODE"],
                  errorMessage: value?.["ERROR-DESC"],
                });
              });

              $("#crifReport").modal("show");
              $("#crifReport").css("z-index", "1050");
              this.CRIFApiShow = true;
            } else {
              this.showSpinner = false;
              const blob = new Blob([this.crifResponse.toString()], {
                type: "text/html",
              });
              this.blobToBase64Async(
                blob,
                "Crif_" +
                  this.loanSummary.ApplicationNo +
                  "_" +
                  this.CustomerId.toString() +
                  ".html",
              );
              //$("#crifReport").modal("show");
              //$("#crifReport").css("z-index", "1050");
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Crif Report Successfully Saved!!",
                ...this.configSuccess,
              });
              this.CRIFApiShow = false;
            }
          });
        }
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Please update the relationship type. C/O is not accepted by CRIF.",
          ...this.configSuccess,
        });
      }
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Update CRC Type!!",
        ...this.configSuccess,
      });
    }
  }
  onCloseCrifReport() {
    this.OnClose(true);
    $("#crifReport").modal("hide");
  }
  CheckCRIFDigiverification(){
        this.showSpinner = true;
        this.CrifAPIDigiverificationShow = false;
         var _findPan = this.kycList.find((x) => x.DocId == 1);

         if (!_findPan) {
        
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Please Add PAN!!",
            ...this.configSuccess,
          });
          this.showSpinner = false;
          this.CrifAPIDigiverificationShow = true;
        
      }
      if (_findPan){
        var dataReq = {
          LoginUserId: this.currentUser.userId,
          LoanId: this.LoanId,
          CustomerId: this.CustomerId,
          ApplicationNo: this.ApplicationDetail.ApplicationNo,
          FirstName: this.ApplicationDetail.Customer_FirstName,
          LastName: this.ApplicationDetail.Customer_LastName,
          MobileNo: this.ApplicationDetail.Customer_PhoneNo,
          PanNo: _findPan.KYC_DocNumber
        }
        console.log("dataReq", dataReq)
        // this._MasterService.FetchCRIF_DigiVerification(dataReq
        // ).subscribe((res: any) => {
        //   console.log("res", res);
        //    this.snackBar.openFromComponent(SnackbarComponent, {
        //         data: "Crif Report Successfully Saved!!",
        //         ...this.configSuccess,
        //       });
        //               this.GetLmsCRCCustomerDetail();

        // })
        this._MasterService.FetchCRIF_DigiVerification(dataReq).subscribe(
        (res: any) => {
          console.log("res", res);
          if (res?.Status === false) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res?.Message || "Report Not Fetched!!",
              ...this.configSuccess,
            });
            this.showSpinner = false;
            this.CrifAPIDigiverificationShow = true;
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "Crif Report Successfully Saved!!",
              ...this.configSuccess,
            });
            this.GetLmsCRCCustomerDetail();
          }
        },
        (err: any) => {
          this.showSpinner = false;
          this.CrifAPIDigiverificationShow = true;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: err?.error?.Message || "Error occurred during CRIF DigiVerification Check!",
            ...this.configSuccess,
          });
        }
      );
      }

  }

  CheckCibilsurepass() {
    this.CibilApisurepassShow = false;
    this.showSpinner = true;

    if (
      this.ApplicationDetail.LoanAmount == undefined ||
      this.ApplicationDetail.LoanAmount == null ||
      this.ApplicationDetail.LoanAmount == 0
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please fill Account Information!!",
        ...this.configSuccess,
      });
      this.showSpinner = false;
    } else {
      var _findPan = this.kycList.find((x) => x.DocId == 1);
      var _findAadhaar = this.kycList.find((x) => x.DocId == 6);

      if (!_findPan) {
        if (!_findAadhaar) {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Please Add PAN or Aadhaar No!!",
            ...this.configSuccess,
          });
          this.CibilApisurepassShow = true;
        }
      }
      if (_findPan || _findAadhaar) {
        var _data;
        if (_findPan) {
          _data = {
            mobile: this.ApplicationDetail.PhoneNo,
            pan: _findPan.KYC_DocNumber,
            name: this.ApplicationDetail.Customer,
            gender: this.ApplicationDetail.Gender.toLowerCase(),
            consent: "Y",
          };
        } else {
          _data = {
            name: this.ApplicationDetail.Customer,
            mobile: this.ApplicationDetail.PhoneNo,
            id_number: _findAadhaar.KYC_DocNumber,
            consent: "Y",
            id_type: "aadhaar",
            report_type: "json",
          };
        }

        this.LmsService.Surepass_Fetch_Civil({
          loginUserId: this.currentUser.userId,
          loanId: this.LoanId,
          CustomerId: this.CustomerId,
          JSON: JSON.stringify(_data),
        }).subscribe((res: any) => {
          console.log("res", res);
          if (res != "") {
            this.ResponseSurePass = res;
            this.cibilResponseSurePass = res;
            console.log("Cibil SUREPass JSON", this.cibilResponseSurePass);

            this.error = this.cibilResponseSurePass?.success;
            console.log("error", this.error);
            if (this.cibilResponseSurePass?.success == true) {
              this.showSpinner = false;
              this.error = this.cibilResponseSurePass?.success;
              $("#cibilReportSurePass").modal("show");
              $("#cibilReportSurePass").css("z-index", "1050");
              this.CibilApisurepassShow = false;
            } else {
              this.showSpinner = false;
              $("#cibilReportSurePass").modal("show");
              $("#cibilReportSurePass").css("z-index", "1050");
              this.CibilApisurepassShow = true;
            }
          }
        });
      }
    }
  }

  onClosecibilReportSurePass() {
    this.OnClose(true);
    $("#cibilReportSurePass").modal("hide");
  }
  getCRCThirdSurePassDetail() {
    this._MasterService
      .Get_CibilAPI_Request_Response({
        Loan_Id: this.LoanId,
        CId: this.CustomerId,
        CrcId: 1,
      })
      .subscribe((res: any) => {
        console.log("res", res);
        if (res.length > 0) {
          this.cibilResponseSurePass = JSON.parse(res[0].response);

          console.log("Cibil JSON", this.cibilResponse);
          $("#cibilReportSurePass").modal("show");
          $("#cibilReportSurePass").css("z-index", "1050");
        }
      });
  }
  getCRCThirdexperianSurepassDetail() {
    this._MasterService
      .Get_CibilAPI_Request_Response({
        Loan_Id: this.LoanId,
        CId: this.CustomerId,
        CrcId: 3,
      })
      .subscribe((res: any) => {
        console.log("res", res);
        if (res.length > 0) {
          this.experianResponse = JSON.parse(res[0].response);

          $("#experianReport").modal("show");
          $("#experianReport").css("z-index", "1050");
        }
      });
  }

  checkExperianAPI() {
    this.cibilCheckType = "experianAPI";
    this.CkeckCibilOtpMsg(this.ApplicationDetail?.PhoneNo);
    // if(cibilOTP==false){
    // this.checkExperian();
    // }
  }
  CheckCibilAPI() {
    this.cibilCheckType = "CibilAPI";
    this.CkeckCibilOtpMsg(this.ApplicationDetail?.PhoneNo);
    // if(cibilOTP==false){
    // this.CheckCibil();
    // }
  }
  CheckCibilsurepassAPI() {
    this.cibilCheckType = "surepassAPI";
    this.CkeckCibilOtpMsg(this.ApplicationDetail?.PhoneNo);
    // if(cibilOTP==false){
    // this.CheckCibilsurepass();
    // }
  }

  CheckCRIFAPI() {
    this.cibilCheckType = "CRIFAPI";
    this.CkeckCibilOtpMsg(this.ApplicationDetail?.PhoneNo);
    // if(cibilOTP==false){
    // this.CheckCRIF();
    // }
  }
  CheckCRIFAPIDigiverification() {
    this.cibilCheckType = "CrifAPIDigiverification";
    this.CkeckCibilOtpMsg(this.ApplicationDetail?.PhoneNo);
    // if (cibilOTP == false) {
    //   this.CheckCRIF();
    // }
  }
  CheckCibildecisioncentreAPI() {
    this.cibilCheckType = "CibildecisioncentreAPI";
    this.CkeckCibilOtpMsg(this.ApplicationDetail?.PhoneNo);
    // if(cibilOTP==false){
    // this.CheckCibildecisioncentre();
    // }
  }
  CheckEquifaxAPI() {
    this.cibilCheckType = "equifaxAPI";
    this.CkeckCibilOtpMsg(this.ApplicationDetail?.PhoneNo);
  }

  CkeckCibilOtpMsg(MobileNo) {
    // this._MasterService.Get_SMS_Detail_Exists({ stepName: 'Cibil OTP' })
    //   .subscribe((res: any) => {
    //     if (res.length > 0 && res[0].CODE == 0) {
    //       this.loading = false;
    //       this.showSpinner = false;
    //       this._MasterService.MessageSendOTP({ MobileNo: MobileNo, stepName: 'Cibil OTP' }).subscribe((res: any) => {
    //         if (res.length > 0 && res[0].CODE == 1) {
    //           this.OTPCode = res[0].MSG;
    //           $("#OTPModel").modal("show");
    //           $("#OTPModel").css("z-index", "1050");
    //           return true;
    //         }
    //       });

    //     }
    let payload = {
      Phone_No: MobileNo,
    };
    this._MasterService
      .SendEventBasedNotif({
        LoanId: this.LoanId,
        EventName: "CibilOTP",
        JSON: payload,
        IsCustomer: 1,
      })
      .subscribe((response: any) => {
        const smsSuccess = response?.SMS?.[0].Code == 1;
        const mailSuccess = response?.Email?.Success === true;
        const waSuccess = response?.WA?.IsSuccess === true;
        // if (response.SMS[0].Code == 1) {
        if (smsSuccess || mailSuccess) {
          // this.OTPCode = response.SMS[0].MSG;
          if (smsSuccess) {
            this.OTPCode = response.SMS[0].Msg;
          } else if (mailSuccess) {
            this.OTPCode = response?.Email?.Msg;
            // ⚠️ Change this if OTP is in a different Email field
          } else if (waSuccess) {
            this.OTPCode = response?.WA?.Msg;
          }
          $("#OTPModel").modal("show");
          $("#OTPModel").css("z-index", "1050");
          return true;
        } else {
          if (this.cibilCheckType == "experianAPI") {
            this.checkExperian();
          }
          if (this.cibilCheckType == "CibilAPI") {
            this.CheckCibil();
          }
          if (this.cibilCheckType == "surepassAPI") {
            this.CheckCibilsurepass();
          }
          if (this.cibilCheckType == "CRIFAPI") {
            this.CheckCRIF();
          }
          if (this.cibilCheckType == "CibildecisioncentreAPI") {
            this.CheckCibildecisioncentre();
          }
          if (this.cibilCheckType == "equifaxAPI") {
            this.CheckEquifax();
          }
          if (this.cibilCheckType == "CrifAPIDigiverification") {
            this.CheckCRIFDigiverification();
          }
          return false;
        }
      });
    return false;
  }
  onOTPModelClose() {
    $("#OTPModel").modal("hide");
  }
  onOTPModelOTP() {
    if (this.OTPCode != this.OTP) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "OTP is not valid",
        ...this.configSuccess,
      });
      return;
    } else {
      this.loading = false;
      $("#LoginOTPModel").modal("hide");
      this.OTPCode = "";
      this.onOTPModelClose();
      if (this.cibilCheckType == "experianAPI") {
        this.checkExperian();
      }
      if (this.cibilCheckType == "CibilAPI") {
        this.CheckCibil();
      }
      if (this.cibilCheckType == "surepassAPI") {
        this.CheckCibilsurepass();
      }
      if (this.cibilCheckType == "CRIFAPI") {
        this.CheckCRIF();
      }
      if (this.cibilCheckType == "CibildecisioncentreAPI") {
        this.CheckCibildecisioncentre();
      }
      if (this.cibilCheckType == "equifaxAPI") {
        this.CheckEquifax();
      }
      if (this.cibilCheckType == "CrifAPIDigiverification") {
            this.CheckCRIFDigiverification();
          }
    }
  }

  FetchCibil(row: any) {
    const defaultAgency = this.ApplicationDetail.DefaultCRCAgency;

    const isDefaultAdded = this.CRCList.some(
      (obj: any) =>
        obj.CRC_Agency == defaultAgency &&
        obj.CRC_LoanId == this.loanSummary.LoanId,
    );

    // 🚫 BLOCK: If user is trying to add NON-default before default
    if (!isDefaultAdded && row.CRC_Agency != defaultAgency) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please add default CRC first before adding other agencies.",
        ...this.configSuccess,
      });
      return;
    }
    this.dialog
      .openConfirmDialog(
        `Are you sure you want to add previous CRC? Once bind with this loan new cannot be fetched!`,
      )
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          console.log("rowdata", row);
          this.showSpinner = true;

          // 🔥 Store the row data to use later
          this.selectedRowForFetch = row;

          this.DocModel = {
            DocData: "",
            DocName: "",
            ApplicationNo: "",
          };
          this.DocModel1 = {
            DocData: "",
            DocName: "",
            ApplicationNo: "",
          };

          // Use previous application number to fetch the file
          const fileUrl =
            this.docBaseUrl + row.Application_No + "/" + row.CRC_ReportName;

          this.http.get(fileUrl, { responseType: "blob" }).subscribe(
            (blob: Blob) => {
              const reader = new FileReader();

              reader.onload = () => {
                const base64String = (reader.result as string).split(",")[1];

                this.DocModel.DocData = base64String;
                this.DocModel.DocName = row.CRC_ReportName;
                this.DocModel.ApplicationNo = this.loanSummary.ApplicationNo; // Current application

                // 🔥 Prepare CRC model with the data from the row
                this.crcModel = {
                  ...row, // Copy all data from the row
                  CRC_ApplicationId: 0,
                  LoanId: this.loanSummary.LoanId,
                  CRC_CustomerId: this.CustomerId,
                  CRC_CreateBy: this.currentUser.userId,
                  CRC_ReportName: row.CRC_ReportName, // Keep the report name
                  CRC_ReportName1: row.CRC_ReportName1,
                  CRC_Id: 0, // Ensure it's a new record
                  CRC_LoanId: this.loanSummary.LoanId, // Set to current loan
                };

                // Format dates if needed
                if (this.crcModel.CRC_OldestAccountOpenDate) {
                  this.crcModel.CRC_OldestAccountOpenDate = new Date(
                    this.crcModel.CRC_OldestAccountOpenDate,
                  );
                }
                if (this.crcModel.CRC_RecentAccountOpenDate) {
                  this.crcModel.CRC_RecentAccountOpenDate = new Date(
                    this.crcModel.CRC_RecentAccountOpenDate,
                  );
                }
                if (this.crcModel.CRC_LastEnquiryDate) {
                  this.crcModel.CRC_LastEnquiryDate = new Date(
                    this.crcModel.CRC_LastEnquiryDate,
                  );
                }

                this.UploadCrcDoc(); // continue flow
              };

              reader.onerror = () => {
                this.showSpinner = false;
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: "Failed to convert file to base64.",
                  ...this.configSuccess,
                });
              };

              reader.readAsDataURL(blob);
            },
            (err) => {
              this.showSpinner = false;
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Failed to fetch previous CRC file.",
                ...this.configSuccess,
              });
            },
          );
        }
      });
  }

  CheckEquifax() {
    var panDoc = this.kycList
      ? this.kycList.find((x: any) => x.DocId == 1)
      : null;
    var panNum = this.panNumberforExperian || panDoc?.KYC_DocNumber || "";

    if (!panNum || panNum.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please fill the PAN Number!",
        ...this.configSuccess,
      });
      return;
    }

    this.showSpinner = true;

    let customerName = (this.ApplicationDetail?.Customer || "").trim();
    let nameParts = customerName ? customerName.split(" ") : [];
    let firstName =
      this.ApplicationDetail?.Customer_FirstName ||
      (nameParts.length > 0 ? nameParts[0] : "");
    let lastName =
      this.ApplicationDetail?.Customer_LastName ||
      (nameParts.length > 1 ? nameParts.slice(1).join(" ") : "");

    let dobRaw =
      this.ApplicationDetail?.Customer_DOB || this.ApplicationDetail?.DOB || "";
    let dob = "";
    if (dobRaw) {
      let d = new Date(dobRaw);
      if (!isNaN(d.getTime())) {
        let yyyy = d.getFullYear();
        let mm = String(d.getMonth() + 1).padStart(2, "0");
        let dd = String(d.getDate()).padStart(2, "0");
        dob = `${yyyy}-${mm}-${dd}`;
      } else {
        dob = dobRaw.toString();
      }
    }

    let payload = {
      PhoneNumber:
        this.ApplicationDetail?.PhoneNo ||
        this.ApplicationDetail?.Customer_PhoneNo ||
        "",
      FirstName: firstName,
      LastName: lastName,
      DateOfBirth: dob,
      PanNumber: panNum,
      Gender: this.ApplicationDetail?.Gender || "",
      Address: this.ApplicationDetail?.Address || "",
      Pincode:
        this.ApplicationDetail?.PinCode ||
        this.ApplicationDetail?.Pincode ||
        "",
      CallbackUrl: "",
      RedirectUrl:
        "http://demo.finnaux.in/#/lms/loan-info/hH9WTmqMCynsgEuc5F4Ulw%253D%253D/L",
      LoanId: Number(this.LoanId || this.loanSummary?.LoanId || 0),
      LoginUserId: Number(this.currentUser?.userId || 0),
      CustomerId: Number(
        this.CustomerId || this.ApplicationDetail?.CustomerId || 0,
      ),
    };

    this.LmsService.CreateBureauConsent_Signzy(payload).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        console.log("Equifax Signzy Response:", res);
        let redirectUrl =
          res?.Result?.Url ||
          res?.result?.url ||
          res?.result?.Url ||
          res?.Result?.url;
        if (redirectUrl) {
          window.open(redirectUrl, "_blank");
        }
        let msg =
          res?.message ||
          res?.result?.message ||
          "Equifax Check request completed successfully!";
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: msg,
          ...this.configSuccess,
        });
        this.GetLmsCRCCustomerDetail();
      },
      error: (err: any) => {
        this.showSpinner = false;
        console.error("Equifax Signzy Error:", err);
        let errorMsg =
          err?.error?.message ||
          err?.error?.details ||
          (typeof err?.error === "string"
            ? err.error
            : "Error occurred during Equifax Check!");
        if (typeof errorMsg === "object") {
          errorMsg = JSON.stringify(errorMsg);
        }
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: errorMsg,
          ...this.configSuccess,
        });
      },
    });
  }
  Get_CibilAPI_Error_Response(){
    this._MasterService.Get_CibilAPI_Error_Response({
      LoanId: this.loanSummary.LoanId,
      CustomerId: this.CustomerId
    }).subscribe((res: any) => {
        console.log("res", res);
       if (res.length > 0) {
      const callbackData = JSON.parse(res[0].CallBack);

      const errorMessage = callbackData?.result?.error?.message;

      console.log("Error Message:", errorMessage); // "Consumer not found in bureau"

      // show it wherever you need, e.g.
      this.EquifaxErrorMessage = errorMessage;
    }
      });

  }
}
